<template>
    <Catalogs
      title="Тип расходов объекта"
      create-text="Новый"
      :fetch-data="fetchData"
      :route-create="'LocationCostTypeAdd'"
      :route-edit="'LocationCostTypeEdit'"
      :route-view="'LocationCostTypeView'"
      :route-path="'/location_cost_types'"
      :can-edit="canEditLocationCostTypeCatalogs()"
    />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Catalogs from "../Catalogs.vue";

export default {
  name: "LocationCostTypes",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  methods: {
    async fetchData(data) {
      return await this.getLocationCostTypes(data);
    },
    canEditLocationCostTypeCatalogs() {
      return this.hasPermission([PERM.CATALOG_LOCATION_COST_TYPE_EDIT]);
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/LocationCostTypes/LocationCostTypes.vue